import { zefDialogOpen, zefDialogClose } from '@zerops/zef/dialog';
import { FEATURE_NAME } from './code-server-overlay.constant';
import { CodeServerOverlayMeta } from './code-server-overlay.model';

export const codeServerOverlayOpen = (meta: CodeServerOverlayMeta) =>
  zefDialogOpen({ key: FEATURE_NAME, meta });

export const codeServerOverlayClose = () =>
  zefDialogClose({ key: FEATURE_NAME });
